import React, { useState } from "react";
import { Check, Copy } from "lucide-react";

/** A link to share, with a Copy button. `label` names what is copied when it isn't a link
    (an agent's number, a sign-in code), for the button's accessible name. */
export function LinkField({ url, label = "link" }: { url: string; label?: string }) {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    await navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };
  return (
    <div className="flex items-center gap-2 px-2.5 h-9 rounded-[8px] bg-[var(--surface-sunk)] ring-1 ring-[var(--hairline-strong)]">
      <span className="flex-1 min-w-0 truncate font-mono text-[12px] text-[var(--text-secondary)]" title={url}>{url}</span>
      <button type="button" onClick={copy} aria-label={`Copy ${label}`}
        className="press shrink-0 flex items-center gap-1 text-[12px] text-[var(--text-secondary)] hover:text-[var(--text-primary)]">
        {copied ? <Check className="w-3.5 h-3.5" strokeWidth={2} /> : <Copy className="w-3.5 h-3.5" strokeWidth={1.75} />}
        {copied ? "Copied" : "Copy"}
      </button>
    </div>
  );
}
